import { RegisterWithEmail } from '@/application/auth/RegisterWithEmail';
import { LoginWithEmail } from '@/application/auth/LoginWithEmail';
import { RequestPasswordReset } from '@/application/auth/RequestPasswordReset';
import { RequestRegisterCode } from '@/application/auth/RequestRegisterCode';
import { VerifyRegisterCode } from '@/application/auth/VerifyRegisterCode';
import { VerifyRegisterOtp } from '@/application/auth/VerifyRegisterOtp';
import { CompleteRegister } from '@/application/auth/CompleteRegister';
import { AuthApiClient } from '@/infrastructure/auth/AuthApiClient';

export const createAuthDependencies = () => {
  const authApiClient = new AuthApiClient();
  return {
    registerWithEmail: new RegisterWithEmail(authApiClient),
    requestRegisterCode: new RequestRegisterCode(authApiClient),
    verifyRegisterCode: new VerifyRegisterCode(authApiClient),
    verifyRegisterOtp: new VerifyRegisterOtp(authApiClient),
    completeRegister: new CompleteRegister(authApiClient),
    loginWithEmail: new LoginWithEmail(authApiClient),
    requestPasswordReset: new RequestPasswordReset(authApiClient),
  };
};

